export default __webpack_public_path__ + "static/media/11.a27bbf3c.jpeg";